import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Rocket } from "lucide-react";
import { siteData } from "../mock";
import Starfield from "./Starfield";

const CTABand = () => {
  return (
    <section className="py-24 bg-[#05070d]">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="relative overflow-hidden rounded-3xl p-10 md:p-16 border border-white/10 text-white bg-gradient-to-br from-[#0b1220] via-[#0e1a34] to-[#0b1220]">
          <Starfield count={30} />
          <div className="absolute -right-16 -top-16 w-80 h-80 rounded-full bg-blue-500/25 blur-3xl" />
          <div className="absolute -left-16 -bottom-20 w-80 h-80 rounded-full bg-purple-500/25 blur-3xl" />

          <div className="relative grid grid-cols-1 md:grid-cols-3 gap-10 items-center">
            <div className="md:col-span-2">
              <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 border border-white/15 text-[11px] tracking-[0.2em] font-semibold">
                <Rocket className="w-3 h-3 text-blue-300" /> LAUNCH READY
              </span>
              <h2 className="mt-4 text-3xl md:text-5xl font-bold tracking-tight leading-[1.05]">
                Let’s make your IT <span className="gradient-text">boring — in the best possible way.</span>
              </h2>
              <p className="mt-4 text-white/75 max-w-2xl leading-relaxed">{siteData.cta.body}</p>
            </div>
            <div className="md:justify-self-end">
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-white text-[#0b1220] font-semibold hover:bg-blue-50 hover:-translate-y-0.5 transition-all shadow-[0_10px_30px_-10px_rgba(255,255,255,0.5)]"
              >
                {siteData.cta.button}
                <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTABand;
